import Vue from 'vue'
import App from './App.vue'
import crypto from './crypto/crypto'
import webcrypto from './crypto/cryptoencrypt'
import router from './router'
import store from './store'
import axios from 'axios'
import plug from './plug/index'
import Http from './http/index'
import HttpsEncrypt from './http/indexencrypt'//接口加密
import Https from './utils/https.js'
import iView from 'iview'
import 'iview/dist/styles/iview.css'
import VueI18n from 'vue-i18n'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.prototype.$crypto = crypto //前端路由加密
Vue.prototype.$webcrypto = webcrypto //前后端加密解密

//引入video样式
import VideoPlayer from 'vue-video-player'

import 'video.js/dist/video-js.css'
import 'vue-video-player/src/custom-theme.css'
//引入hls.js
import 'videojs-contrib-hls.js/src/videojs.hlsjs'

Vue.use(VideoPlayer)


Vue.prototype.axios = axios;
axios.defaults.baseURL = '/api'
Vue.prototype.$http = Http
Vue.prototype.$uuid = require('uuid')
Vue.prototype.$https = Https
Vue.prototype.$httpsencrypt = HttpsEncrypt
Vue.use(plug)
Vue.use(iView)
Vue.use(VueI18n)
Vue.use(ElementUI);


import BaiduMap from 'vue-baidu-map'

Vue.use(BaiduMap, {
    ak: 'LLn5Q9UemGwfly5CE2nlWhjIEvZsKZfi'//自己去百度API申请，免费的
})

// 设置公共的颜色样式
function changeThemeColor(color) {
    //'#0047BE'
    document.body.style.setProperty('--themeColor', '#0047BE');
}

const i18n = new VueI18n({
    locale: 'mn',    // 语言标识
    //this.$i18n.locale // 通过切换locale的值来实现语言切换
    messages: {
        'zh': require('./assets/lang/zh'),   // 中文语言包
        'mn': require('./assets/lang/mn'),    // 英文语言包
        'en': require('./assets/lang/en')    // 英文语言包
    }
})


import VueLazyload from 'vue-lazyload'

Vue.use(VueLazyload, {
    preLoad: 1.3,
    error: require('./assets/images/default.jpg'),
    loading: require('./assets/images/loading.gif'),
    lazyComponent: true
})
/************************************************************
 *
 * 检索时失去焦点
 *
 ************************************************************/
Vue.prototype.$getOnBlur = function (data) {
    let old = data.trim()
    // // 奥云
    // let aoyun = '\s+ᠵᠢᠨ|\s+᠊ᠤᠨ|\s+᠊ᠦ|\s+ᠳ᠋ᠤ᠌|\s+ᠲᠤ᠌|\s+ᠶ᠋ᠢ|\s+᠊ᠢ|\s+ᠠ᠋ᠴᠠ|\s+ᠲᠠᠢ|\s+ᠪᠠᠷ|\s+ᠵᠢᠠᠷ|\s+ᠪᠡᠨ|\s+ᠵᠢᠠᠨ|\s+ᠳ᠋ᠦ᠍ᠷ|\s+ᠲᠤᠷ|s+᠊ᠤᠤ'
    // // 德力海
    // let delihai = '|\s+ᠢᠨ|\s+᠎ᠤᠨ|\s+᠎ᠤ|\s+᠎ᠢ|\s+ᠵᠢ|\s+᠎ᠳᠤ|\s+᠎ᠲᠤ|\s+᠎ᠲᠠᠢ|\s+᠎ᠡᠴᠡ|\s+᠎ᠪᠡᠷ|\s+᠎ᠢᠶᠡᠨ|\s+᠎ᠪᠡᠨ|\s+᠎ᠢᠶᠡᠷ|\s+᠎ᠳᠤᠷ|\s+᠎ᠲᠤᠷ'
    // // 蒙科力标准
    // let mklbz = '|\s+ᠤᠨ|\s+ᠪᠠᠷ|\s+ᠶ᠋ᠢ|\s+ᠪᠠᠷ|\s+ᠪᠠᠨ|\s+ᠤᠳ|\s+ᠦᠦ'
    // // 蒙科力
    // let mkl = '|\s+ᠶᠢᠨ|\s+᠎ᠤᠨ|\s+᠎ᠤ|\s+᠎ᠳ᠋ᠦ᠍|\s+᠎ᠲᠤ|\s+ᠶᠢ|\s+᠎ᠢ|\s+᠎ᠡᠴᠡ|\s+᠎ᠲᠠᠢ|\s+᠎ᠪᠠᠷ|\s+᠎ᠢᠶᠡᠷ|\s+᠎ᠪᠠᠨ|\s+᠎ᠢᠶᠡᠨ|\s+ᠦᠦ'
    let reg = /\s+ᠵᠢᠨ|\s+᠊ᠤᠨ|\s+᠊ᠦ|\s+ᠳ᠋ᠤ᠌|\s+ᠲᠤ᠌|\s+ᠶ᠋ᠢ|\s+᠊ᠢ|\s+ᠠ᠋ᠴᠠ|\s+ᠲᠠᠢ|\s+ᠪᠠᠷ|\s+ᠵᠢᠠᠷ|\s+ᠪᠡᠨ|\s+ᠵᠢᠠᠨ|\s+ᠳ᠋ᠦ᠍ᠷ|\s+ᠲᠤᠷ|s+᠊ᠤᠤ|\s+ᠢᠨ|\s+᠎ᠤᠨ|\s+᠎ᠤ|\s+᠎ᠢ|\s+ᠵᠢ|\s+᠎ᠳᠤ|\s+᠎ᠲᠤ|\s+᠎ᠲᠠᠢ|\s+᠎ᠡᠴᠡ|\s+᠎ᠪᠡᠷ|\s+᠎ᠢᠶᠡᠨ|\s+᠎ᠪᠡᠨ|\s+᠎ᠢᠶᠡᠷ|\s+᠎ᠳᠤᠷ|\s+᠎ᠲᠤᠷ|\s+ᠤᠨ|\s+ᠪᠠᠷ|\s+ᠶ᠋ᠢ|\s+ᠪᠠᠷ|\s+ᠪᠠᠨ|\s+ᠤᠳ|\s+ᠦᠦ|\s+ᠶᠢᠨ|\s+᠎ᠤᠨ|\s+᠎ᠤ|\s+᠎ᠳ᠋ᠦ᠍|\s+᠎ᠲᠤ|\s+ᠶᠢ|\s+᠎ᠢ|\s+᠎ᠡᠴᠡ|\s+᠎ᠲᠠᠢ|\s+᠎ᠪᠠᠷ|\s+᠎ᠢᠶᠡᠷ|\s+᠎ᠪᠠᠨ|\s+᠎ᠢᠶᠡᠨ|\s+ᠦᠦ/g
    let ss = old.replace(reg, "-");
    let ll = ss.split("-").filter(item => item).join(" ")
    let ss1 = ll.replace(/\s+/g, "-")
    let ll1 = ss1.split("-").filter(item => item).join(" ")
    return ll1
}


Vue.config.productionTip = false

/************************************************************
 *
 * 保存用户行为
 *
 ************************************************************/
function saveUserBehavior(to, from) {
    Vue.prototype.$UserBehaviorsort++
    let data = {
        member_id: (localStorage.getItem('userInfoMemberId') ? JSON.parse(Vue.prototype.$crypto.get(localStorage.getItem('userInfoMemberId'))).member_id : null),// 用户id
        library_id: (localStorage.getItem('theme_color') ? JSON.parse(Vue.prototype.$crypto.get(localStorage.getItem('theme_color'))).library_id : null),// 馆藏id
        book_id: null,// 数据ID（书籍id、期刊id）
        magazine_id: null,// 杂志id
        type: to.meta.type,// 类型 1书籍 2杂志
        path: to.path,// 路由
        name: to.name ? to.name : to.meta.name,//名称

        wificode: store.getters.wificode,// Wi-Fi码
        devicecode: store.getters.uuid,//设备码
        network: store.getters.network,// 网络
        latlon: store.getters.latlon,// 经纬度
        ip: '',//网络ip
        apptype: '',
        appterminal: '',
        appterminallx: '',//终端具体类型和软件的版本号
        apiterminal: 'Aqt_20230517ApiWeb',
        terminal: Vue.prototype.$terminal,
        created_at: Vue.prototype.$getNowTime(),//年月日时分秒
        sort: Vue.prototype.$UserBehaviorsort,
        priceclass_id: '',//专题分类id
        menu_id: '',//菜单id
    }
    //  书籍详情+期刊详情+报刊详情+知识库详情+作者详情+儿童名详情
    if (to.path == '/BookDetails' || to.path == '/JournalDetails' ||
        to.path == '/NewspapersDetais' || to.path == '/QuestionBankDetails' ||
        to.path == '/AuthorDetails' || to.path == '/VideoFrequencyListDetails' ||
        to.path == '/VideoFrequencyListDetails' || to.path == '/JournalMue'
    ) {
        data.book_id = Vue.prototype.$crypto.get(to.query.id)
        data.magazine_id = null
    }
    if (to.path == '/SongDetails') {
        data.book_id = Vue.prototype.$crypto.get(to.query.ItemInfor)
        data.magazine_id = null
    }


    axios.post('https://culture.aqitai.com/api/web/v1/book/userbehavior', data).then(val => {
    }).catch(err => {
    })

}

function loginPd(next) {
    axios.get('https://culture.aqitai.com/api/web/v1/member/getsigndata?login_id=' + JSON.parse(Vue.prototype.$crypto.get(localStorage.getItem('userInfos'))).login_id).then(val => {
        if (val.data.code == 200 && val.data.data.quit_at) {
            localStorage.removeItem("userInfoMemberId");
            localStorage.removeItem("userInfos");
            next('/login')

        } else {
            if (localStorage.getItem('userInfos')) {
                let userDatas = JSON.parse(Vue.prototype.$crypto.get(localStorage.getItem('userInfos')))
                var how = new Date(userDatas.last_login_time);
                var today = new Date();
                if (parseInt((today.getTime() - how.getTime()) / 1000 / 60 / 60) >= 6) {

                    localStorage.removeItem("userInfoMemberId");
                    localStorage.removeItem("userInfos");
                    next('/login')
                } else {
                    next()
                }
            } else {
                next('/login')
            }

        }
    }).catch(err => {
    })
}

Vue.prototype.$loginPd = function () {
    if (localStorage.getItem('userInfos') && JSON.parse(Vue.prototype.$crypto.get(localStorage.getItem('userInfos'))).login_id) {
        axios.get('https://culture.aqitai.com/api/web/v1/member/getsigndata?login_id=' + JSON.parse(Vue.prototype.$crypto.get(localStorage.getItem('userInfos'))).login_id).then(val => {
            if (val.data.code == 200 && val.data.data.quit_at) {
                localStorage.removeItem("userInfoMemberId");
                localStorage.removeItem("userInfos");
                Vm.$router.push({path: '/login', query: {lib_type: sessionStorage.getItem('gcm')}})
                document.title = ''

            } else {
                if (localStorage.getItem('userInfos')) {
                    let userDatas = JSON.parse(Vue.prototype.$crypto.get(localStorage.getItem('userInfos')))
                    var how = new Date(userDatas.last_login_time);
                    var today = new Date();
                    if (parseInt((today.getTime() - how.getTime()) / 1000 / 60 / 60) >= 6) {
                        localStorage.removeItem("userInfoMemberId");
                        localStorage.removeItem("userInfos");
                        Vm.$router.push({path: '/login', query: {lib_type: sessionStorage.getItem('gcm')}})
                        document.title = ''
                    }
                }

            }
        }).catch(err => {
        })
    }
    if (localStorage.getItem('userInfos') && !JSON.parse(Vue.prototype.$crypto.get(localStorage.getItem('userInfos'))).login_id) {
        localStorage.removeItem("userInfoMemberId");
        localStorage.removeItem("userInfos");
        Vm.$router.push({path: '/login', query: {lib_type: sessionStorage.getItem('gcm')}})
        document.title = ''
    }
}

Vue.prototype.$UserBehaviorsort = 0

router.beforeEach((to, from, next) => {
    // 判断网址是在手机端打开的还是在pc端打开的
    let library_id = ''
    let lang = localStorage.getItem('lang')?localStorage.getItem('lang'):'mn'
    if (localStorage.getItem("theme_color")) {
        let library_infor = JSON.parse(Vue.prototype.$crypto.get(localStorage.getItem("theme_color")))
        document.title = (library_infor && library_infor.name_lang ?
            (localStorage.getItem('lang') == 'mn'?(library_infor.name_lang.mn || library_infor.name_lang.zh):(library_infor.name_lang.zh || library_infor.name_lang.mn)):
        '阿启泰优质资源')
        library_id = library_infor.library_id
    } else {
        document.title = ''
        library_id = ''
    }
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (isMobile) {
        //当前在手机端
        let query = '&lang='+lang+'&app_library_id=' + library_id+'&aqt_resources=true' + '&mode_version=gbt&isShare=/'
        // window.location = 'http://bookstore.aqitai.com/#' +'/JudgeApp?newVal=' + encodeURIComponent(JSON.stringify(query))
        window.location = 'http://bookstore.aqitai.com/#' + '/JudgeApp?newVal=' + encodeURIComponent(JSON.stringify(query))
    } else {
        // 当前在PC端

        if (to.path == '/External') {
            const gcm = 'school'
            sessionStorage.setItem('gcm', gcm)
        } else if (to.path == '/aqt') {
            const gcm = to.query.lib_type || 'aqt'
            sessionStorage.setItem('gcm', gcm)
        }

        window.addEventListener("beforeunload", () => {
            //页面刷新了
            Vue.prototype.$UserBehaviorsort = 0
        })

        if (sessionStorage.getItem('isNewVisit') === null) {
            //页面是新开的
            Vue.prototype.$UserBehaviorsort = 0
            sessionStorage.setItem('isNewVisit', 'false');
        } else {
            //页面不是新开的
        }

        Vue.prototype.$terminal = 2  //1代表终端是APP 产品平板电脑10

        changeThemeColor()
        store.dispatch('getSebeihao').then(() => {
        })
        store.dispatch('getNetworkType').then(() => {
        })
        store.dispatch('getMap').then(() => {
        })


        // 保存用户行为
        saveUserBehavior(to, from)

        if (to.path != '/login') {
            if (!localStorage.getItem('userInfoMemberId')) {
                document.title = ''
                next({path: '/login', query: {'lib_type': sessionStorage.getItem("gcm")}})
            } else {
                if (localStorage.getItem('userInfos')) {
                    // next()
                    if (to.path == '/aqt'||to.path == '/External') {
                        if((localStorage.getItem('lang') && localStorage.getItem('lang') == 'zh')){
                            next('/zhver')
                        }else {
                            next()
                        }
                    } else if (to.path == '/zhver' ) {
                        if(!localStorage.getItem('lang') || localStorage.getItem('lang') == 'mn'){
                            // next('/')
                            if (sessionStorage.getItem('gcm') == 'school') {
                                next({path: '/External', query: {lib_type: sessionStorage.getItem('gcm')}})
                            } else {
                                next({path: '/aqt', query: {lib_type: sessionStorage.getItem('gcm')}})
                            }

                        }else {
                            next()
                        }
                    } else {
                        next()
                    }
                }
            }
        } else if (to.path == '/login') {
            document.title = ''
            if (!localStorage.getItem('userInfoMemberId')) {
                next()
            } else {
                next()
            }
        } else {
            if (localStorage.getItem('userInfos')) {
                // loginPd(next)
                next()
            }


        }

    }


})

window.Vm = new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app')
